<script setup>
import {inject} from "vue";

const need = inject('need');

</script>

<template>
    <aside class="dashboard-page__sidebar dashboard-page__sidebar--bordered">
        <h3 class="dashboard-page__title mb-4">About This Need</h3>

        <h3 class="heading3 mb-4">{{ need.name }}</h3>

        <p>{{ need.has_submissions ? need.company_name : need.company_label }}</p>

        <p class="mb-4 pb-2">Created {{ need.created_at }}</p>

        <p>{{need.description}}</p>
    </aside>
</template>

<style scoped>

</style>
